module.exports = __webpack_public_path__ + "static/media/RosaSamanthaMoralesGonzalez.cba6c7b4.png";